<ion-app *ngIf="dbLoaded">
  <ion-router-outlet></ion-router-outlet>
</ion-app>

<div *ngIf="!dbLoaded" style="text-align: center; height: 300px; display: flex; align-items: center; justify-content: center; height: 100vh !important; width: 100% !important">
  <ion-spinner class="syncLoader"></ion-spinner>
</div>
